export const AUTH_QUERY_TOKENS_WINDOW_KEY = '__CAKTO_AUTH_QUERY_TOKENS__';

export const isBankingRoutePath = (pathname = '') => {
  const normalizedPath = String(pathname).toLowerCase().replace(/\/+$/, '');

  return (
    normalizedPath === '/dashboard/financial' ||
    normalizedPath.startsWith('/dashboard/financial/') ||
    normalizedPath === '/dashboard/banking' ||
    normalizedPath.startsWith('/dashboard/banking/')
  );
};

const normalizeTokens = (tokens) => {
  if (!tokens || typeof tokens !== 'object') return null;

  const accessToken = typeof tokens.accessToken === 'string' ? tokens.accessToken : null;
  const refreshToken = typeof tokens.refreshToken === 'string' ? tokens.refreshToken : null;

  return accessToken !== null || refreshToken !== null ? { accessToken, refreshToken } : null;
};

const consumeBootstrapTokens = () => {
  const tokens = normalizeTokens(window[AUTH_QUERY_TOKENS_WINDOW_KEY]);

  try {
    delete window[AUTH_QUERY_TOKENS_WINDOW_KEY];
  } catch (_error) {
    window[AUTH_QUERY_TOKENS_WINDOW_KEY] = undefined;
  }

  return tokens;
};

const captureAndScrubUrlTokens = () => {
  const url = new URL(window.location.href);
  const hasAccessToken = url.searchParams.has('accessToken');
  const hasRefreshToken = url.searchParams.has('refreshToken');

  if (!hasAccessToken && !hasRefreshToken) return null;

  const tokens = {
    accessToken: hasAccessToken ? url.searchParams.get('accessToken') : null,
    refreshToken: hasRefreshToken ? url.searchParams.get('refreshToken') : null,
  };

  url.searchParams.delete('accessToken');
  url.searchParams.delete('refreshToken');

  const search = url.searchParams.toString();
  const sanitizedUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;

  try {
    window.history.replaceState(window.history.state, document.title, sanitizedUrl);
  } catch (_error) {
    // Sem a limpeza o token fica na URL, como ficava antes; sem o token o login para. A sessão
    // vale mais que a URL limpa, e o erro aqui é o mesmo que o bootstrap já engoliu.
  }

  return tokens;
};

// O bootstrap do index.html deixa o handoff no window em qualquer rota, mas o AuthProvider não
// monta em todas (PublicLayout, 404). Tirar do window na carga do bundle encurta a janela em que
// um script de terceiro poderia lê-lo pelo nome ao intervalo entre o <head> e o bundle.
let pendingBootstrapTokens = typeof window === 'undefined' ? null : consumeBootstrapTokens();

export const consumeAuthQueryTokens = () => {
  if (typeof window === 'undefined') return null;

  const bootstrapTokens = pendingBootstrapTokens ?? consumeBootstrapTokens();
  pendingBootstrapTokens = null;
  const urlTokens = captureAndScrubUrlTokens();

  return bootstrapTokens || urlTokens;
};
